import * as angular from 'angular';
import PlansService from './plans.service';
import PlansStateService from './plans.state.service';
import Card from './card/card.index';
import Subscription from './subscription/subscription.index';
import LimitUsers from './limit.users.service';
import NameFilter from "./name.filter";

// TODO remove
export default angular.module('CrazyWeb.Plans', [Card, Subscription])
    .service("PlansService", PlansService)
    .service("PlansStateService", PlansStateService)
    .service("LimitUsers", LimitUsers)
    .filter("nameFilter", NameFilter)
    .name
